import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, Typography, Box, Divider, Skeleton } from '@mui/material';
import { getContentAffinityKeywords } from '../../../../redux/thunks/affinityHubThunk';
import { HighChartTreemapChart } from '../../../shared';
import { ActionsIcon } from '../../../../assets';
import {
    CHART_OPTIONS_KEYWORD_1,
    CHART_OPTIONS_KEYWORD_2,
    CHART_OPTIONS_KEYWORD_3,
} from './constants';

function ContentAffinity(props) {
    const { } = props;
    const dispatch = useDispatch();
    const { contentAffinity } = useSelector(state => state.affinityHub);
    const { data, 
        keyword1,
        keyword2, 
        keyword3, 
        totalKeywords1Count,
        totalKeywords2Count,
        totalKeywords3Count,
        isLoading, 
    } = contentAffinity;
    
    useEffect(() => {
        dispatch(getContentAffinityKeywords());
    }, []);

    return (
        <Box className="box-sizing-border-box">
            <Typography className="text-md-semi-bold gray-900">
                Content Affinity
            </Typography>
            <Box className="padding-tb-24-rl-0">
                <Grid container spacing={'24px'} className="flex-row br-16px">
                    {/*  Keyword 1 */}
                    <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                        <Box className="padding-24px bg-gray-50 br-16px">
                            <Box className="pb-24px">
                                <Box className="flex-column gap-4">
                                    <Box className="flex-row-space-between">
                                        <Box>
                                            <Typography className="text-md-semi-bold gray-900">
                                                Keyword 1
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Typography className="text-sm-regular gray-500">
                                            {totalKeywords1Count} Overall Keywords
                                        </Typography>
                                    </Box>
                                </Box>
                                <Divider className="border-1-gray mt-20px" />
                            </Box>
                            {isLoading ? <Skeleton height={350} /> : <HighChartTreemapChart
                                chartOptions={
                                    {
                                        ...CHART_OPTIONS_KEYWORD_1,
                                        series: keyword1.chartSeries,
                                    }
                                }
                            />}
                        </Box>
                    </Grid>
                    {/*  Keyword 2 */}
                    <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                        <Box className="padding-24px bg-gray-50 br-16px">
                            <Box className="pb-24px">
                                <Box className="flex-column gap-4">
                                    <Box className="flex-row-space-between">
                                        <Box>
                                            <Typography className="text-md-semi-bold gray-900">
                                                Keyword 2
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Typography className="text-sm-regular gray-500">
                                            {totalKeywords2Count} Overall Keywords
                                        </Typography>
                                    </Box>
                                </Box>
                                <Divider className="border-1-gray mt-20px" />
                            </Box>
                            {isLoading ? <Skeleton height={350} /> : <HighChartTreemapChart
                                chartOptions={
                                    {
                                        ...CHART_OPTIONS_KEYWORD_2,
                                        series: keyword2.chartSeries,
                                    }
                                }
                            />}
                        </Box>
                    </Grid>
                    {/*  Keyword 3 */}
                    <Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
                        <Box className="padding-24px bg-gray-50 br-16px">
                            <Box className="pb-24px">
                                <Box className="flex-column gap-4">
                                    <Box className="flex-row-space-between">
                                        <Box>
                                            <Typography className="text-md-semi-bold gray-900">
                                                Keyword 3
                                            </Typography>
                                        </Box>
                                    </Box>
                                    <Box>
                                        <Typography className="text-sm-regular gray-500">
                                            {totalKeywords3Count} Overall Keywords
                                        </Typography>
                                    </Box>
                                </Box>
                                <Divider className="border-1-gray mt-20px" />
                            </Box>
                            {/* Keyword 3 Bubble Chart*/}
                            {isLoading ? <Skeleton height={350} /> : <HighChartTreemapChart
                                chartOptions={
                                    {
                                        ...CHART_OPTIONS_KEYWORD_3,
                                        series: keyword3.chartSeries,
                                    }
                                }
                            />}
                        </Box>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    );
}

export default ContentAffinity;
